import { render, staticRenderFns } from "./Expansionpanel.vue?vue&type=template&id=3ce0ff65&"
import script from "./Expansionpanel.vue?vue&type=script&lang=js&"
export * from "./Expansionpanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports